
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/form/pool",
      function () {
        return require("private-next-pages/form/pool.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/form/pool"])
      });
    }
  